import scss from "./ScoreNumber.module.scss";

export const ScoreNumber = ({ number }) => {
  const styles = {
    color: number > 0 ? "#418BFA" : "#FF4949",
    textShadow:
      number > 0
        ? "0px 0px 5px rgba(66, 140, 250, 0.97)"
        : "0px 0px 5px rgba(255, 73, 73, 0.97)",
  };

  return (
    <p className={scss.scoreNumber} style={styles}>
      {number > 0 && "+"}
      {number}
    </p>
  );
};
